<template>
    <v-app>
        <header-card-public current_page="support"></header-card-public>
         <v-content class="bg">
            <v-layout row wrap >          
                <v-flex xs12> 
                    <v-card class="elevation-1" :style="contentMargin">
                        <v-toolbar flat height="45px">
                            <h1 class="font-weight-bold subheading">Support</h1>
                        </v-toolbar>
                        <v-card-text class="subheading text-xs-left" style="padding:20px 30px 20px 30px;">
                            Please email <b>support@sweldonow.ph</b>
                        </v-card-text>
                    </v-card>        
                </v-flex>
            </v-layout>
         </v-content>
    </v-app>
</template>
<script>

import '@/assets/css/public.css'

export default {
    name: 'Support',
    metaInfo: {
        title: 'Support',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Read FAQ, Pricing, Knowledge Hub or email us at support@sweldonow.ph' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'header-card-public': () => import('@/components/Common/HeaderPublic')
    },
    data () {
        return {
            error: false,
            errorMessage: null,
            drawer: false,
            icons: [
                {icon: 'fab fa-facebook', link: 'https://www.facebook.com/Accureos-101753728463338', title: 'Accureos Facebook page'},
                {icon: 'fab fa-youtube', link: 'https://www.youtube.com/channel/UCSlaGhEXs2hMiWthvmOzWAg', title: 'Accureos Youtube channel'},
            ]
        }
    },   
    methods: {
        OpenWindow(url) {
            if (url!='') window.open(url, '_blank')
        }  
    },
    computed: {
        contentMargin() {
            return this.isMobile? "margin:100px 20px 20px 20px" : "margin:150px 200px 0px 200px"
        }
    },
    created() {}
  }
</script>